  import React, { useState, useEffect } from 'react';
  import {Link} from "react-router-dom";
  import styles from "./component.module.scss"
  import logo from '../../../../assets/logoClub.webp';
  import { useForm } from "react-hook-form";
  import axios from 'axios';
  import no_minor from "../../../../assets/no-minor.png";

  interface RegisterFormData {
    lastName: string;
    firstName: string;
    pseudo: string;
    email: string;
    street: string;
    cp: string;
    city: string;
    phone: string;
    club: string;
    age: boolean;
  }

  const DEFAULT_VALUES: RegisterFormData = {
    lastName: '', firstName: '', pseudo: '', email: '', street: '',
    cp: '', city: '', phone: '', club: '', age: false,
  };

  const API_URL = 'https://labuzifpokerclub.fr';
  const EVENT_DAY = "Poker Tour du samedi 28 Novembre 9H";
  const CP_REGEX = /^\d{5}$/;

  const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
  const PHONE_REGEX = /^0\d{9}$/;

  // Supprime espaces et caractères spéciaux; +33 / 0033 devient 0
  function normalizePhone(phone: string): string {
    const cleaned = phone.trim().replace(/[^\d+]/g, '').replace(/^(\+33|0033)/, '0');
    return cleaned.replace(/\D/g, '');
  }

  type TextField = Exclude<keyof RegisterFormData, 'age'>;

  const FIELDS: { name: TextField; label: string; placeholder: string; type?: string; required?: boolean; error?: string; rules?: object }[] = [
    { name: 'lastName', label: 'Nom', placeholder: 'Nom', required: true, error: 'Veuillez saisir votre nom !' },
    { name: 'firstName', label: 'Prénom', placeholder: 'Prénom', required: true, error: 'Veuillez saisir votre prénom !' },
    { name: 'pseudo', label: 'Pseudo', placeholder: 'Pseudo', required: true, error: 'Veuillez saisir un pseudo !', rules: { validate: (v: string) => v.trim() !== '' } },
    { name: 'email', label: 'Adresse mail', placeholder: 'Adresse mail', type: 'email', required: true, error: 'Veuillez saisir une adresse mail valide !', rules: { pattern: EMAIL_REGEX } },
    { name: 'street', label: 'N° et voie', placeholder: 'ex: 30, rue grande', required: true, error: 'Veuillez saisir une adresse postale valide !' },
    { name: 'cp', label: 'Code postal', placeholder: 'ex: 28260', required: true, error: 'Veuillez saisir un code postal valide !', rules: { pattern: CP_REGEX } },
    { name: 'city', label: 'Ville', placeholder: 'anet', required: true, error: 'Veuillez saisir une ville valide !' },
    { name: 'phone', label: 'Tél', placeholder: '06........', required: true, error: 'Veuillez saisir un numéro de téléphone valide !', rules: { validate: (v: string) => PHONE_REGEX.test(normalizePhone(v)) } },
    { name: 'club', label: 'Votre club (optionnel)', placeholder: 'Votre club' },
  ];

  const MAX_REGISTER_POKER_TOUR = 160;

  function Home() {
    const [nbRegisterPokerTour, setRegisterPokerTour] = useState<number | null>(null);

    useEffect(() => {
      axios.get(`${API_URL}/back/api/count_register.php`)
        .then((response) => setRegisterPokerTour(response.data['players']))
        .catch(console.error);
    }, []);

    const {
      register,
      handleSubmit,
      watch,
      reset,
      setError,
      formState: { errors, isSubmitting },
    } = useForm<RegisterFormData>({ defaultValues: DEFAULT_VALUES });

    const isAdult = watch("age");
    const isFull = nbRegisterPokerTour !== null && nbRegisterPokerTour >= MAX_REGISTER_POKER_TOUR;

    const onSubmit = async (data: RegisterFormData) => {
      const pseudo = data.pseudo.trim();
      try {
        await axios.post(`${API_URL}/back/api/email.php`, {
          form: 'Inscription Poker Tour',
          firstName: data.firstName.trim(),
          lastName: data.lastName.trim(),
          pseudo,
          email: data.email.trim(),
          street: data.street.trim(),
          cp: data.cp.trim(),
          city: data.city.trim(),
          phone: normalizePhone(data.phone),
          club: data.club.trim(),
        });
        reset(DEFAULT_VALUES);
        alert(`Votre demande d'inscription a été prise en compte ${pseudo}\nRendez-vous au ${EVENT_DAY}\nGood luck!`);
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 409) {
          setError("pseudo", { type: "duplicate", message: "Ce pseudo est déjà inscrit !" });
          return;
        }
        console.error(error);
        alert("Une erreur est survenue, veuillez réessayer plus tard.");
      }
    };

      return (   
        <section className={styles.main}>
          <div>
            <button><Link to="/pokertour">Inscrit au poker tour</Link></button>
          </div>
          <div className={styles.container}>
            <div className={styles.affiche}>
              {isFull && <div className={styles.full}>
                <p className={styles.textfull}>Complet!</p>
                <p className={styles.textfull}>Victime de son succès.</p>
              </div>}
              <p><img src={logo} alt="logo" className={styles.rotating}/></p>
              <h2 className={styles.title}><span className={styles.red}>POKER </span>TOUR</h2>
              <p className={styles.date}>Samedi 28 Novembre</p>
              <p className={styles.open}>Début du tournoi à 10h00</p>
              <p className={styles.open}>Entrée tardive 30 minutes</p>
              <p className={styles.open}>Ouverture des portes 9h00</p>
              <p className={styles.details}>Deep stack, Hold&apos;em No limit</p>
              <p className={styles.details}><span className={styles.red}>50K</span> jetons et Round de <span className={styles.red}>30</span> minutes</p>
              <p className={styles.details}>Tournoi FREEROLL</p>
              <p className={styles.separator}></p>
              <p className={styles.details}>Limité à 160 joueurs</p>
              <p className={styles.separator}></p>
              <p className={styles.details}>Restauration & Buvette sur place</p>
              <p className={styles.separator}></p>
              <address>
                <p>Salle des fêtes, 2 rue des fossés, 28410 Bû</p>
              </address>
              <p className={styles.details}>Pour toutes questions, Urbella au 06.35.34.59.70</p>
              <p className={styles.details}>Inscription via notre formulaire sur https://labuzifpokerclub.fr</p>
              <p className={styles.open}><span className={styles.red}>Inscription Obligatoire</span></p>
              <p className={styles.open}><img src={no_minor} alt="logo no minor" className={styles.noMinor}/></p>
            </div>
            <div className={styles.registrer}>
              <form className={styles.formContact} onSubmit={handleSubmit(onSubmit)}>
                <h3 className={styles.title}>Formulaire d'inscription</h3>
                {FIELDS.map(({ name, label, placeholder, type = 'text', required, error, rules }) => (
                  <div className={styles.formItem} key={name}>
                    <label htmlFor={name}>{label} {required && <span className={styles.red}>*</span>}</label>
                    <p><input type={type} placeholder={placeholder} id={name} {...register(name, { required, ...rules })}/></p>
                    {errors[name] && <span className={styles.red}>{errors[name]?.message || error}</span>}
                  </div>
                ))}
                <div className={styles.formItemInline}>
                  <input type="checkbox" id="age" {...register("age")}/>
                  <label htmlFor="age">Je certifie avoir plus de 18 ans</label>
                </div>
                <div className={styles.formItem}>
                  <p className={styles.blockSubmit}>
                    <input type="submit" name="sendMessage" value="Inscription" id="sendMessage" className={styles.button62} disabled={!isAdult || isSubmitting}/>
                  </p>
                </div>
              </form> 
            </div> 
          </div>
        </section>
    );
  }

  export default Home;


